// This file was generated by svgr, do not edit it.
import * as React from 'react'
import { clsx } from 'clsx'
import styles from '../Icon.module.css'
import {
  computeStrokeWidth,
  computeSize,
  getIconColorClassName,
} from '../helpers'
import type { IconProps, IconComponentRef } from '../helpers'
const ThumbsUpFilledIcon = React.forwardRef(
  (
    { size, stroke, className, color, ...props }: IconProps,
    ref: IconComponentRef,
  ) => {
    const iconName = 'thumbs-up-filled'
    const computedSize = computeSize(size)
    const computedStrokeWidth = computeStrokeWidth(computedSize, stroke)
    return (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={clsx(className, styles.base, getIconColorClassName(color))}
        data-icon={iconName}
        aria-hidden="true"
        strokeWidth={computedStrokeWidth}
        width={computedSize}
        height={computedSize}
        ref={ref}
        {...props}
      >
        <path
          d="M6.5 23H4.5C3.70435 23 2.94152 22.6837 2.37891 22.1211C1.81632 21.5585 1.5 20.7957 1.5 20V12C1.50002 11.2044 1.81632 10.4415 2.37891 9.87895C2.94151 9.31637 3.70437 9.00005 4.5 9.00005H6.5V23Z"
          fill="currentColor"
        />
        <path
          d="M12.5127 1.00005C13.1347 1.0078 13.747 1.15612 14.3037 1.43364C14.8606 1.71129 15.3479 2.11129 15.7285 2.60356C16.1091 3.09576 16.3734 3.66769 16.502 4.27641C16.6302 4.88386 16.6189 5.51243 16.4707 6.11528L16.4717 6.11626L15.7715 9.00005H20.3301C20.7958 9.00006 21.2553 9.10819 21.6719 9.31645C22.0884 9.52473 22.451 9.82769 22.7305 10.2002C23.0097 10.5726 23.1979 11.0051 23.2812 11.4629C23.3541 11.8637 23.3447 12.2751 23.2539 12.6709L23.21 12.8399L20.8799 20.8399C20.6981 21.463 20.3191 22.011 19.7998 22.4004C19.2806 22.7898 18.649 23 18 23H8.5V7.75493L11.6055 1.55278C11.777 1.21033 12.1297 0.995304 12.5127 1.00005Z"
          fill="currentColor"
        />
      </svg>
    )
  },
)
ThumbsUpFilledIcon.displayName = 'ThumbsUpFilledIcon'
export { ThumbsUpFilledIcon }
